// src/components/progressNavigator.js

export function redirectToProgressStep(step, navigate) {
    switch (step) {
      case "NOT_STARTED":
        console.log("Redirecting to Dashboard");
        navigate('/dashboard', { replace: true });
        window.location.reload();
        break;
      case "PRE_EXPERIMENT":
        console.log("Redirecting to Pre-Experiment");
        navigate('/pre-experiment', { replace: true });
        window.location.reload();
        break;
      case "DOCUMENTATION_INTRO":
        console.log("Redirecting to Documentation Intro (legacy)");
        navigate('/documentation-intro', { replace: true });
        window.location.reload();
        break;
      case "DOCUMENTATION_REVIEW":
        console.log("Redirecting to Documentation Review");
        navigate('/documentation-review', { replace: true });
        window.location.reload();
        break;
      case "PLATFORM_TUTORIAL":
        console.log("Redirecting to Platform Tutorial");
        navigate('/platform-tutorial', { replace: true });
        window.location.reload();
        break;
      case "EXPERIMENT":
        console.log("Redirecting to Experiment");
        navigate('/experiment', { replace: true });
        window.location.reload();
        break;
      case "WEBSITE1":
        console.log("Redirecting to Website");
        navigate('/website1', { replace: true });
        window.location.reload();
        break;
      case "WEBSITE2":
        // Website2 is disabled for now — redirect to post-experiment instead
        console.log("Website2 disabled — redirecting to Post-Experiment");
        navigate('/post-experiment', { replace: true });
        window.location.reload();
        break;
      case "POST_EXPERIMENT":
        console.log("Redirecting to Post-Experiment");
        navigate('/post-experiment', { replace: true });
        window.location.reload();
        break;
      case "END":
        console.log("Redirecting to Thank You Page");
        navigate('/thank-you', { replace: true });
        window.location.reload();
        break;
      default:
        console.log("Unknown step, redirecting to Dashboard");
        navigate('/dashboard', { replace: true });
        window.location.reload();
    }
  }
  